<script>
    // import axios from "axios";
    
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import moment from "moment";
    import { mapGetters, mapActions, mapState } from "vuex";
    
    /**
     * Advanced table component
     */
    export default {
      page: {
        title: "Customer Balance Details",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        PageHeader,
      },
      data() {
        return {
         current_date: moment(new Date()).format("YYYY-MM-DD"),
          title: "Customer Balance Details",
          items: [
            {
              text: "Home",
              href: "#/",
            },
            {
              text: "Customer Balance Details",
              active: true,
            },
          ],

          json_fields: {
            NAME: "customer.name",
            CONTACT: "customer.contact",
            DATE: "date",
            AMOUNT_IN:"amountIn",
            AMOUNT_OUT:"amountOut",
            DESCRIPTION:"Description",
            CATEGORY:"Category",
            RECORDED_BY:"user",
          },
          json_meta: [
            [
              {
                key: "charset",
                value: "utf-8",
              },
            ],
          ],

          total_amount:0,
          total_paid:0,
          total_balance:0,
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100, 200, 1000],
          filter: null,
          todoFilter: null,
          filterOn: [],
          todofilterOn: [],
          sortDesc: false,
          totals:{
            totalin:0,
            totalout:0,
          },
          fields: [
            {
              key: "date",
              sortable: true,
              label: "DATE",
            },
            {
              key: "amountIn",
              sortable: true,
              label: "AMOUNT IN",
            },
            {
              key: "amountOut",
              sortable: true,
              label: "AMOUNT OUT",
            },
            {
              key: "Category",
              sortable: true,
              label: "CATEGORY",
            },
            {
              key: "user",
              sortable: true,
              label: "RECORDED BY",
            }, 
            {
              key: "newbalance",
              sortable: true,
              label: "BALANCE",
            }      
           
          ],
         
        };
      },
      computed: {
        ...mapState("notification", [
          "notificationtype",
          "notification_message",
          "notification_show",
        ]),
        ...mapGetters("customers", [
          "CustomerBalanceDetails"
        ]),
        ...mapGetters("setting", ["ReceiptSettings"]),
    
        /**
         * Total no. of records
         */
    
        rows() {
          return this.CustomerBalanceDetails ? this.CustomerBalanceDetails.length : 1;
        },
      },
      mounted() {
        // Set the initial number of items
        this.totalRows = this.CustomerBalanceDetails ? this.CustomerBalanceDetails.length : 1;
      },
      methods: {
        ...mapActions({
          FetchBalanceDetails: "customers/fetchCustomerBalanceDetails",
          fetchReceiptSettings: "setting/fetchReceiptSettings",
        }),
        thousandSeperator(m) {
          if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
            return m
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          } else {
            return m;
          }
        },
       /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },

        Receipt_print(newValue) {      
          window.open(
            `https://${window.location.host}/receipts/depositreceipt.php?id=${btoa(newValue)}`
          );
        },
     },
     updated() {
        let total_in = 0;
        let total_out = 0;
        if(this.CustomerBalanceDetails){
            this.CustomerBalanceDetails.forEach((item)=>{
                total_in = total_in+parseInt(item.amountIn);
            });
            this.totals.totalin = total_in;
            this.CustomerBalanceDetails.forEach((item)=>{
                total_out = total_out+parseInt(item.amountOut);
            });
            this.totals.totalout = total_out;
        }
  },
      created() {
        this.FetchBalanceDetails(this.$route.params.id);
        this.fetchReceiptSettings();
      },
    };
    </script>
    
    <template>
      <Layout>
        <Toasts
          :show-progress="true"
          :rtl="true"
          :max-messages="20"
          :time-out="3000"
          :closeable="false"
          :solid="true"
        ></Toasts>
        <div class="row py-3 text-center">
          <h4 class="text-primary">CUSTOMER PAYMENT REPORT FOR {{CustomerBalanceDetails[0].customer.name}} - {{CustomerBalanceDetails[0].customer.contact}} <br/>
            Page - {{ CustomerBalanceDetails[0].records?CustomerBalanceDetails[0].records.page:'' }} Chassis - {{ CustomerBalanceDetails[0].records?CustomerBalanceDetails[0].records.chassis:'' }} No.Plate - {{ CustomerBalanceDetails[0].records?CustomerBalanceDetails[0].records.noplate:'' }} 
          </h4>
        </div>
        <PageHeader :title="title" :items="items" />        
        <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-2">
                    <download-excel
                      class="btn btn-info"
                      :data="CustomerBalanceDetails"
                      :fields="json_fields"
                      :worksheet="'CUSTOMER BALANCE DETAILS AS OF ' + current_date"
                      type="csv"
                      :name="'Customerbalance_details ' + current_date + '.xls'"
                    >
                      Export <i class="fa fa-download"></i>
                    </download-excel>
                  </div>
                  <div class="col-md-7" align="center">
                    <router-link :to="`/customer/print_balance_details/${$route.params.id}`">
                      <b-button variant="warning"><i class="fa fa-print"></i> Print</b-button>
                    </router-link>
                  </div>
                  <div class="col-md-3" align="right">
                      <b-button @click="$router.go(-1)" variant="warning"><i class="fa fa-undo"></i> Back</b-button>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          class="form-select form-select-sm"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                    class="datatables"
                    :items="CustomerBalanceDetails"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                    >
                    <template #cell(amountIn)="data">
                    {{ data.item.amountIn?thousandSeperator(data.item.amountIn):0 }}
                    </template>
                    <template #cell(amountOut)="data">
                    {{ data.item.amountOut?thousandSeperator(data.item.amountOut):0 }}
                    </template>
                 </b-table>
                 <div class="row">
                  <div class="col-md-4">
                    <h5>Total In: <span class="text-danger">{{totals.totalin?thousandSeperator(totals.totalin):0}}</span></h5>
                  </div>
                  <div class="col-md-4">
                    <h5>Total Out: <span class="text-danger">{{totals.totalout?thousandSeperator(totals.totalout):0}}</span></h5>
                  </div>
                  <div class="col-md-4">
                    <h5>Total Balance: <span class="text-danger">{{(totals.totalout - totals.totalin)?(totals.totalout - totals.totalin).toLocaleString():0}}</span></h5>
                  </div>
                </div>
                  <div style="text-align: center">
                    <h3 v-if="!CustomerBalanceDetails" class="text-primary">
                      <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                      Please wait...
                    </h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                   </div>
                </div>
            </div>
          </div>
      </Layout>
    </template>
    